import { CREATE_TRAINING, EDIT_TRAINING, GET_TRAINING, GET_TRAINING_BY_COMPETENCY, GET_TRAINING_DETAIL, GET_TRAINING_DETAIL_PROPOSSED } from "@/api/master-data/training/training";
import queryString from "query-string";

const state = {
    training: [],
    createTraining: [],
    trainingDetail:[],
    trainingDetailPropossed:[],
    trainingProviderCompetency:[]
};
const mutations = {
    setTraining: (states, payload) => {
        states.training = payload;
    },
    setCreateTraining: (states, payload) => {
        states.createTraining = payload
    },
    setDetailTraining: (states, payload) => {
        states.detailTraining = payload
    },
    setDetailTrainingPropossed: (states, payload) => {
        states.trainingDetailPropossed = payload
    },

    setTrainingProviderCompetency: (states, payload) => {
        states.trainingProviderCompetency = payload
    },

};
const actions = {
    getTraining: async ({ commit }, args) => {
        const params = queryString.stringify(args);

        try {
            const resp = await GET_TRAINING(params);
            // console.log("resppp", resp)
            if (resp.data.httpCode === 200) {
                commit("setTraining", resp.data);
                return resp.data;
            }
        } catch (err) {
            const resp = err.response;
            // console.log(resp)
            if (resp.data.httpCode === 404) {
                commit("setTraining", []);
            }
            throw err;
        }
    },
    createTraining: async ({ commit }, args) => {
        try {
            const resp = await CREATE_TRAINING(args);
            if (resp.data.httpCode === 200) {
                commit("setCreateTraining", resp.data);
                return resp.data;
            }
        } catch (err) {
            const resp = err.response;
            if (resp.data.httpCode === 404) {
                commit("setCreateTraining", []);
            }
            throw err;
        }
    },
    updateTraining: async ({ }, args) => {
        return await EDIT_TRAINING(args);
    },
    detailTraining: async ({ commit }, args) => {

        try {
            const resp = await GET_TRAINING_DETAIL(args);
            // console.log("resppp", resp)
            if (resp.data.httpCode === 200) {
                commit("setDetailTraining", resp.data);
                return resp.data;
            }
        } catch (err) {
            const resp = err.response;
            // console.log(resp)
            if (resp.data.httpCode === 404) {
                commit("setDetailTraining", []);
            }
            throw err;
        }
    },

    detailTrainingPropossed: async ({ commit }, args) => {
        try {
            const resp = await GET_TRAINING_DETAIL_PROPOSSED(args);
            if (resp.data.httpCode === 200) {
                commit("setDetailTrainingPropossed", resp.data);
                return resp.data;
            }
        } catch (err) {
            const resp = err.response;
            if (resp.data.httpCode === 404) {
                commit("setDetailTrainingPropossed", []);
            }
            throw err;
        }
    },

    getTrainingByProviderByCompentency: async ({ commit }, { providerId, competency }) => {
        try {
            const resp = await GET_TRAINING_BY_COMPETENCY(providerId, competency);
            if (resp.data.httpCode === 200) {
                commit("setTrainingProviderCompetency", resp.data.data);
                return resp.data;
            }
        } catch (err) {
            const resp = err.response;
            if (resp.data.httpCode === 404) {
                commit("setTrainingProviderCompetency", []);
            }
            throw err;
        }
    },
};

const getters = {
    Training: (states) => states.training,
    DetailTraining:(states)=> states.detailTraining,
    DetailTrainingPropossed:(states)=> states.trainingDetailPropossed,
    trainingProviderCompetency:(states)=> states.trainingProviderCompetency,
};

export default {
    namespaced: true,
    state,
    mutations,
    actions,
    getters,
};
